<template>
  <div>
    <uni-popup ref="checkDetail" type="bottom">
      <uni-card title="申请单" :is-full="true" :note="true">
        <div class="show_wrap">
          <div class="title">
            <span
              >{{ doctor.hospitalName
              }}{{ getKeyValueText('item_type', checkDetail.prescripOrderType) }}</span
            >
            <span>申请单</span>
          </div>
          <div class="sec_title">
            <span>No.{{ checkDetail.prescriporderNo }}</span>
            <!-- ' ' 中间的空格不要去掉 就是这么写的 -->
            <span class="self">
              {{ getKeyValueText('patient_fee_type', checkDetail.patientFeeType) || ' ' }}
            </span>
          </div>
          <!-- 修复申请单 历史记录3条以后展示不全 -->
          <div class="prescrip-wrap">
            <div class="prescrip-msg">
              <span>
                姓名：
                <span>{{ checkMsg.patientName }}</span>
              </span>
              <span>
                性别：
                <span>{{ checkMsg.patientSex === '2' ? '女' : '男' }}</span>
              </span>
              <span>
                年龄：
                <span>{{ checkMsg.patientAge }}</span>
              </span>
            </div>
            <div class="prescrip-msg">
              <span>
                咨询号：
                <span>{{ visit || '' }}</span>
              </span>
              <span>
                科室：
                <span>{{ checkDetail.deptName }}</span>
              </span>
            </div>
            <div class="prescrip-msg">
              <span>
                日期：
                <span>
                  {{ dayjs(checkDetail.createTime).format('YYYY-MM-DD HH:mm:ss') }}
                </span>
              </span>
              <span>
                手机号：
                <span>{{ checkMsg.patientPhone }}</span>
              </span>
            </div>
            <div class="row_wrap">
              <span class="diagnosis">诊断：</span>
              <div v-if="sysName" class="diagnosis_content">
                <div v-for="(item, i) in sysList" :key="i" class="diagnose_wrap">
                  <span :class="item.symptomType === '3' ? 'meng_text' : 'symptom_text'">
                    {{ item.symptomName || '' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <ms-check-show
            :checkList="checkDetail.treatmentDetailList"
            :prescription="checkDetail.patientName"
            :prescripType="checkDetail.prescripOrderType"
            :patientID="checkDetail.patientID"
            :visitNo="visitNo"
          />
          <div class="prescrip-wrap">
            <div class="prescrip-msg">
              <span>
                医生：
                <span>{{ checkDetail.doctorName }}</span>
              </span>
              <span>
                金额：
                <span>{{ checkDetail.cost }}元</span>
              </span>
              <span>
                自付：
                <span>{{ checkDetail.cost }}元</span>
              </span>
            </div>
          </div>
        </div>
        <template v-slot:footer>
          <div class="serious_wrap">
            <div class="footer-box cancel_btn" @click="cancelCheck">
              <span class="btn">撤销申请</span>
            </div>
            <div class="footer-box update_btn" @click="updateCheck">
              <span class="btn">修改申请</span>
            </div>
          </div>
        </template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
  </div>
</template>
<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import { mapState } from 'vuex'
import { cancelTreatment } from '@/views/funcPuzzle/utils/index.js'
import MsCheckShow from '@/views/funcPuzzle/components/ms-check-show/ms-check-show.vue'
import dayjs from 'dayjs'

export default {
  components: {
    MsCheckShow
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    symptomName: {
      type: [Object, String],
      default: ''
    },
    patientPhone: {
      type: [Object, String],
      default: ''
    },
    visitNo: {
      type: [Object, String],
      default: ''
    },
    seletedIndex: {
      type: [Object, String],
      default: ''
    },
    preLength: {
      type: [String, Number],
      default: () => {
        return 0
      }
    }
  },
  data() {
    return {
      showAddDrug: false,
      checkDetail: {},
      isHis: false,
      checkMsg: {}
    }
  },
  computed: {
    ...mapState(['doctor']),
    sysList() {
      return this.symptomName
    },
    sysName: {
      get() {
        return this.symptomName
      },
      set(val) {
        this.$emit('update:symptomName', val)
      }
    },
    phone: {
      get() {
        return this.patientPhone
      },
      set(val) {
        this.$emit('update:patientPhone', val)
      }
    },
    visit: {
      get() {
        return this.visitNo
      },
      set(val) {
        this.$emit('update:visitNo', val)
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$refs.checkDetail.open()
      } else {
        this.close()
      }
    }
  },
  methods: {
    dayjs,
    getKeyValueText,
    close() {
      if (!this.$refs.checkDetail) {
        return false
      }
      this.$emit('update:visible', false)
      this.$refs.checkDetail.close()
      // if (this.isHis) {
      // }
    },
    createPrescrip() {
      this.close()
    },
    updateCheck() {
      this.$bus.emit('updateCheck', {
        val: this.checkDetail,
        val2: this.seletedIndex,
        val3: this.checkDetail.prescripOrderType
      })

      this.$refs.checkDetail.close()
    },
    cancelCheck() {
      cancelTreatment({
        id: this.checkDetail.id
      }).then(rs => {
        if (rs.code == '0') {
          this.$refs.checkDetail.close()
          uni.showToast({
            title: rs.codeDesc,
            icon: 'none'
          })
        } else {
          // uni.showToast({
          //   title: rs.codeDesc,
          //   icon: 'none'
          // })
        }
      })
    },

    open() {
      this.$refs.checkDetail.open()
    }
  },
  mounted() {
    this.$bus.on('checkDetail', detail => {
      this.checkDetail = detail.checkItem
      this.sysName = detail.symptomName
      this.phone = detail.patientPhone
      this.visit = detail.visitNo
      this.$refs.checkDetail.open()
    })
    this.$bus.on('clickHistoryCheck', val => {
      this.checkDetail = val
      this.sysName = val.symptomName
      this.isHis = true
    })
    this.$bus.on('checkMsg', val => {
      if (val) {
        this.checkMsg = val
      }
    })
  },
  destroyed() {
    this.$bus.off('updateCheck')
    this.$bus.off('backToHisCheck')
  }
}
</script>

<style lang="scss" scoped>
.show_wrap {
  height: 11.946667rem;
  display: flex;
  flex-direction: column;
  height: 18.346667rem;
  overflow-y: scroll;
  // padding: 0 .64rem;
  overflow-x: hidden;
  z-index: 1100;
  .state_wrap {
    position: relative;
    .pre {
      width: 0.853333rem;
      height: 0.853333rem;
      border-radius: 0.085333rem;
      border: 0.021333rem solid #cecece;
      text-align: center;
      line-height: 0.853333rem;
      position: absolute;
      top: 0;
      // margin-left: 6.826667rem;
      right: 0.426667rem;
    }
    .no_state,
    .checkDetail_state {
      font-size: 0.725333rem;
      font-weight: 500;
      line-height: 1.024rem;
    }
    .no_state {
      color: #f86767;
    }
    .checkDetail_state {
      color: #222;
    }
  }

  .title {
    height: 3.2rem;
    text-align: center;
    font-size: 0.768rem;
    font-weight: 500;
    color: #222222;
    line-height: 1.194667rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    margin-bottom: 0.426667rem;
  }
  .sec_title {
    width: 16rem !important;
    // margin-left: -0.682667rem;
    border-bottom: 0.021333rem solid #ececec;
    display: flex;
    justify-content: space-between;
    font-size: 0.64rem;
    font-weight: 400;
    color: #222222;
    line-height: 1.28rem;
    padding: 0 0.682667rem 0.426667rem 0.682667rem;
    box-sizing: border-box;
  }
  .r_style {
    font-size: 1.066667rem;
    font-weight: 400;
    color: #222222;
    line-height: 1.493333rem;
  }
  .blank_row {
    height: 3.285333rem;
    line-height: 3.285333rem;
    text-align: center;
    color: #888;
    font-size: 0.512rem;
  }
  .prescrip-wrap {
    height: auto;
    padding: 0.64rem 0.682667rem 0.682667rem 0.682667rem;
    border-bottom: 0.021333rem solid #ececec;
    width: 16rem !important;
    // margin-left: -0.682667rem;
    border-bottom: 0.021333rem solid #ececec;
    box-sizing: border-box;

    .prescrip-msg {
      display: flex;
      margin-bottom: 0.853333rem;
      text {
        flex: 1;
        font-size: 0.64rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #888;
        line-height: 0.853333rem;
        text:first-child {
          color: #222;
        }
      }
    }
    .validDays {
      color: #ff7555 !important;
      font-size: 0.512rem;
      font-weight: 400;
    }
    .row_wrap {
      width: 100%;
      min-height: 1.92rem;
      position: relative;
      display: flex;
      box-sizing: border-box;
      .diagnosis_content {
        display: flex;
        flex-wrap: wrap;
        .diagnose_wrap {
          width: auto;
          font-size: 0.512rem;
          font-weight: 400;
          color: #222222;
          line-height: 0.682667rem;
          height: 0.682667rem;
          background: #eee;
          padding: 0.085333rem 0.256rem;
          margin: 0 0.512rem 0.426667rem 0;
          .symptom_text {
            font-family: PingFangSC-Regular, PingFang SC !important;
          }
          .meng_text {
            font-family: PingFang-SC-Medium, PingFang SC, Menksoft Budun !important;
          }
        }
      }
      .diagnosis {
        font-size: 0.64rem;
        font-weight: 400;
        color: #888;
        line-height: 0.853333rem;
        min-width: 2.133333rem !important;
      }
      .addDrug {
        color: #0089ff;
        font-size: 0.597333rem;
        position: absolute;
        right: 0.64rem;
      }
    }
  }
  .usage_wrap {
    // height: 4.266667rem;
    .process_method {
      width: 1.450667rem;
      height: 0.853333rem;
      background: #eeeeee;
      border-radius: 0.085333rem;
      text-align: center;
      line-height: 0.853333rem;
      color: #222;
      font-size: 0.512rem;
    }
  }
}
.btn_wrap,
.serious_wrap {
  display: flex;
  justify-content: space-between;
  height: 2.773333rem;
  background: #ffffff;
  // padding: .384rem .682667rem 0 !important;
}
.serious_wrap {
  justify-content: space-around;
}
.footer-box,
.update_btn {
  text-align: center;
  width: 4.416rem;
  height: 1.877333rem;
  line-height: 1.877333rem;
  border-radius: 0.938667rem;
  font-size: 0.682667rem;
}
.footer-box {
  background: #0089ff;
  color: #fff;
}
.update_btn {
  border: 0.021333rem solid #0089ff;
  background-color: #fff;
  color: #0089ff;
}
.cancel_btn {
  border: 0.021333rem solid #ececec;
  color: #222;
  background-color: #fff;
}
</style>
